module.exports = __webpack_public_path__ + "img/prozis-now-white-logo.84ec21ae.svg";